<div id="scannerDisplay" class="transition-all duration-500 h-0 !overflow-hidden"> 
    <iframe src="assets/html/scanner_interface.html" scrolling="no" class="!overflow-hidden w-full h-full border-none"></iframe> 
</div>